import { render, staticRenderFns } from "./InputWebhook.vue?vue&type=template&id=56d62e3e&"
import script from "./InputWebhook.vue?vue&type=script&lang=ts&"
export * from "./InputWebhook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports